import Achievements from './Achievments';
import Forecast from './Forecast';
import TwoColumnLayout from '../layout/TwoColLayout';

function Dashboard() {
  return <TwoColumnLayout sectionLabel='Dashboard' sectionHeading='Your emissions' sectionIntro='' left={<Achievements />} right={<Forecast />} />;
}

export default Dashboard;
